<template>
	<EagleTap version="eaglePro" :tapContext="tapContext" />
</template>
<script>
import EagleTap from './EagleTap'
export default {
	components: {
		EagleTap,
	},
	computed: {
		tapContext() {
			return {
				title: this.getConstants('EAGLE_LANDING_SALE_PRO_TITLE'),
				subTitle: this.getConstants('EAGLE_LANDING_SALE_PRO_SUBTITLE'),
				originPrice: this.getConstants('EAGLE_LANDING_SALE_PRO_ORIGIN_PRICE'),
				edition: this.getConstants('EAGLE_LANDING_SALE_PRO_EDITION'),
				saleText1: this.getConstants('EAGLE_LANDING_SALE_PRO_TEXT1'),
				saleText2: this.getConstants('EAGLE_LANDING_SALE_PRO_TEXT2'),
				saleText3: this.getConstants('EAGLE_LANDING_SALE_PRO_TEXT3'),
				saleTip: this.getConstants('EAGLE_LANDING_SALE_TRAFFIC_TIP'),
			}
		},
	},
}
</script>
